import React from 'react';
import styled from '../../styled';
import { Arrow } from '../icons/outline';
import Tab from './Tab';
const ArrowWrapper = styled.div `
  display: ${({ isDisabled }) => (isDisabled ? 'none' : 'block')};
  position: absolute;
  top: 0;
  left: ${({ left }) => (left ? 0 : 'auto')};
  right: ${({ right }) => (right ? 0 : 'auto')};
  padding: 1.125rem 0.625rem;
  line-height: 0;
  z-index: 1;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.8;
    background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
  }

  &:hover {
    cursor: pointer;

    > svg {
      fill: ${({ theme }) => theme.colors.PRIMARY_600};
    }

    ::before {
      opacity: 0.2;
      background-color: ${({ theme }) => theme.colors.PRIMARY_300};
    }
  }
`;
const Header = styled.div `
  transform: translateZ(0); // hack Tab title disappear in tablet
  position: relative;
  border-bottom: solid 1px ${({ theme }) => theme.colors.INK_300};
  height: 3.5rem;
  padding: 0 1.5rem;
  overflow: hidden;
`;
const TabsWrapper = styled.div `
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;

  > div:not(:last-child) {
    flex-direction: column;
    padding-right: 2rem;
  }
`;
class TabsHeader extends React.Component {
    constructor(props) {
        super(props);
        this.handleResize = () => {
            if (this.tabsWrapperRef.current) {
                const { scrollWidth, clientWidth, scrollLeft, } = this.tabsWrapperRef.current;
                let width = 0;
                let newIndex = 0;
                const maxWidth = scrollWidth - clientWidth;
                const tabs = this.tabsWrapperRef.current.children;
                for (let i = 0; i < tabs.length; i += 1) {
                    width += tabs[i].clientWidth;
                    if (width >= scrollLeft) {
                        newIndex = Math.ceil(i / 2);
                        break;
                    }
                }
                this.setState({
                    maxMoveWidth: maxWidth,
                    moveWidth: scrollLeft,
                    index: newIndex,
                });
            }
        };
        this.handleClick = (direction) => () => {
            const { maxMoveWidth, index } = this.state;
            let newIndex = index;
            if (direction === 'right') {
                newIndex += 1;
            }
            else if (direction === 'left') {
                newIndex -= 1;
            }
            if (this.tabsWrapperRef.current) {
                let itemLength = newIndex * 2;
                const tabs = this.tabsWrapperRef.current.children;
                if (itemLength > tabs.length) {
                    itemLength = tabs.length;
                }
                let width = 0;
                for (let i = 0; i < itemLength; i += 1) {
                    width += tabs[i].clientWidth;
                }
                if (width > maxMoveWidth) {
                    width = maxMoveWidth;
                }
                this.tabsWrapperRef.current.scrollTo({
                    behavior: 'smooth',
                    left: width,
                });
                this.setState({ moveWidth: width, index: newIndex });
            }
        };
        this.state = {
            moveWidth: 0,
            maxMoveWidth: 0,
            index: 0,
        };
        this.tabsWrapperRef = React.createRef();
    }
    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    render() {
        const { backgroundColor, renderTabs } = this.props;
        const { moveWidth, maxMoveWidth } = this.state;
        return (React.createElement(Header, null,
            React.createElement(ArrowWrapper, { left: true, backgroundColor: backgroundColor, isDisabled: moveWidth === 0, onClick: this.handleClick('left') },
                React.createElement(Arrow, { size: "MEDIUM", color: "INK_600", position: "LEFT" })),
            React.createElement(ArrowWrapper, { right: true, backgroundColor: backgroundColor, isDisabled: moveWidth === maxMoveWidth, onClick: this.handleClick('right') },
                React.createElement(Arrow, { size: "MEDIUM", color: "INK_600", position: "RIGHT" })),
            React.createElement(TabsWrapper, { ref: this.tabsWrapperRef, onScroll: this.handleResize }, renderTabs(Tab).map(item => (React.createElement("div", { key: `${item.key}` }, item))))));
    }
}
export default TabsHeader;
//# sourceMappingURL=TabsHeader.js.map